import { create } from "zustand";

const useEquatorialTableDataStore = create(set => ({
  equatorialTableData: [],
  setEquatorialTableData: equatorialTableData => set({ equatorialTableData })
}));

export default useEquatorialTableDataStore;
